export enum treasurySetupFormFields {
  groupName = 'groupName',
  externalPortfolioIds = 'externalPortfolioIds',
  departmentName = 'departmentName',
  departmentDescription = 'departmentDescription',
}
